var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('div',{staticClass:"betting-betslip-box"},[_c('BettingArea'),_c('div',{staticClass:"betslip-box"},[(_vm.appShown)?_c('BetslipC',{attrs:{"betslip-types":_vm.setBetslipTypes}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }